import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { createActionHandler } from '../../util';

import OmInputFieldWrapper from '../forms/OmInputFieldWrapper';
import OmDropdownField from '../forms/OmDropdownField';

import {
    setAmountBorrowedValue,
    setOtherAmountBorrowedValue,
} from '@om/redux/actions/personalLoansCalculator/calculator';

import {
    getAmountBorrowed,
    getOtherAmountBorrowed,
    getOwnAmountMethod,
} from '@om/redux/selectors/personalLoansCalculator/calculator';
import {
    getLoanAmountOptions,
} from '@om/redux/selectors/personalLoansCalculator/referenceData';

const LoanAmountForm = () => {

    const dispatch = useDispatch();

    const {
        loanAmountOptions,
        amountBorrowed,
        otherAmountBorrowed,
        ownAmountMethod,
    } = useSelector(
        createStructuredSelector({
            loanAmountOptions: getLoanAmountOptions,
            amountBorrowed: getAmountBorrowed,
            otherAmountBorrowed: getOtherAmountBorrowed,
            ownAmountMethod: getOwnAmountMethod,
        })
    );

    return (
        <div>
            <OmDropdownField
                useNativeMobileDropdown={true}
                placeholder="How much do you need?"
                required={true}
                id="loanAmount"
                formId="loanAmountDetailsForm"
                name="loanAmount"
                align="left"
                filterable={false}
                onSelectHandler={(event) => { dispatch(setAmountBorrowedValue(event.detail.id)) }}
                reduxValue={amountBorrowed}
                options={
                    loanAmountOptions && loanAmountOptions.map(option => ({ value: option.code, label: option.description }))
                }
            />
            {
                amountBorrowed.value === ownAmountMethod.code
                && <OmInputFieldWrapper
                    persistHandler={createActionHandler(dispatch, setOtherAmountBorrowedValue)}
                    reduxValue={otherAmountBorrowed}
                    placeholder="Enter your own loan amount?"
                    required="true"
                    align="left"
                    prefixString="R"
                    mask="thousands-spaced"
                    formId="otherLoanAmount"
                    keyboardMode="numeric"
                    hintText="Enter an amount between R2 000 and R250 000" />
            }
        </div>
    )
}

export default LoanAmountForm;
